// eslint-disable-next-line no-restricted-imports
import { ButtonColors, ToolbarIconButton, ToolbarIconButtonProps } from '@workday/canvas-kit-react/button';
import { StyledType, createComponent } from '@workday/canvas-kit-react/common';
import { WcpStyles } from '@workday/wcp-tokens';
import { Ref } from 'react';

const toolbarColors = ({ toggled }: ToolbarIconButtonProps): ButtonColors => ({
  default: {
    icon: toggled ? WcpStyles.color.fg.primary.strong : WcpStyles.color.icon.default,
    background: toggled ? WcpStyles.color.bg.primary.softer : 'transparent',
  },
  focus: {
    background: toggled ? WcpStyles.color.bg.alt.strong : 'transparent',
    icon: WcpStyles.color.icon.strong,
  },
  hover: {
    background: toggled ? WcpStyles.color.bg.primary.softer : WcpStyles.color.bg.alt.soft,
    icon: toggled ? WcpStyles.color.fg.primary.strong : WcpStyles.color.icon.strong,
  },
  active: {
    background: WcpStyles.color.bg.alt.default,
    icon: WcpStyles.color.icon.strong,
  },
  disabled: {
    background: toggled ? WcpStyles.color.bg.alt.default : 'transparent',
    icon: WcpStyles.color.icon.default,
    opacity: '40%',
  },
});

export const ThemedToolbarIconButton = createComponent('button')({
  Component: (props: ToolbarIconButtonProps & StyledType, ref: Ref<HTMLButtonElement>, Element) => (
    <ToolbarIconButton ref={ref} as={Element} colors={toolbarColors(props)} {...props} />
  ),
  displayName: 'ThemedToolbarIconButton',
});
